<template>

  <div class="row">

    <FavouriteHome class="mb-6" />

    <HistoryHome class="mb-6" />

    <TdNews class="mb-6" />

    <NearbyRoutes class="mb-6" />

  </div>
</template>

<script>
import FavouriteHome from '../Favourite/FavouriteHome'
import NearbyRoutes from '../NearbyRoutes/NearbyRoutes'
import TdNews from '../Td/TdNews'
import HistoryHome from "../History/HistoryHome";

export default {
  name: "RouteInfoBase",
  components: {
    HistoryHome,
    FavouriteHome, NearbyRoutes, TdNews,

  },

}
</script>

<style scoped>
.spacer-10 {
  width: 100%;
  height: 10px;
  display: block;
}
</style>
